<script>
import CrudList from 'Support/components/crud/CrudList.vue';
import ContratacoesRequest from 'Domain/contratacoes/ContratacoesRequest';
import DataTableCurrencyColumn from 'Support/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableDateOnlyColumn from 'Support/components/data-table/DataTableColumns/DataTableDateOnlyColumn.vue';
import DataTableDateColumn from 'Support/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ContratacoesStatusDataTableColumn from 'App/contratacoes/ContratacoesStatusDataTableColumn.vue';
import BotoesAcaoColumn from 'App/contratacoes/components/botoes-acao/BotoesAcaoColumn.vue';
import DataTableCpfCnpjColumn from 'Support/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import Moment from 'moment';

export default {
  name: 'ContratacoesCrudList',
  extends: CrudList,
  data() {
    return {
      headers: [
        {
          text: this.$t('app.contratacoes.list.headers.status'),
          value: 'statusDaContratacao',
          component: ContratacoesStatusDataTableColumn,
          width: '1%',
        },
        {
          text: this.$t('app.contratacoes.list.headers.clienteIdSgv'),
          value: 'clienteIdSgv',
          orderBy: 'cliente.informacaoTendencia.tendenciaClienteId',
        },
        {
          text: this.$t('app.contratacoes.list.headers.name'),
          value: 'clinteDaContratacao',
        },
        {
          text: this.$t('app.contratacoes.list.headers.document'),
          value: 'cpfCnpj',
          component: DataTableCpfCnpjColumn,
        },
        {
          text: this.$t('app.contratacoes.list.headers.scoreCliente'),
          value: 'scoreCliente',
        },
        {
          text: this.$t('app.contratacoes.list.headers.nomeEmpresa'),
          value: 'nomeEmpresa',
        },
        {
          text: this.$t('app.contratacoes.list.headers.cobrancaId'),
          value: 'cobrancaId',
        },
        {
          text: this.$t('app.contratacoes.list.headers.date'),
          value: 'dataContratacao',
          component: DataTableDateColumn,
          orderBy: 'dataContratacao',
        },
        {
          text: this.$t('app.contratacoes.list.headers.dataPagamento'),
          value: 'dataPagamentoProrrogacao',
          component: DataTableDateOnlyColumn,
        },
        {
          text: this.$t('app.contratacoes.list.headers.valorBoletoSgv'),
          value: 'valorBoletoSgv',
          component: DataTableCurrencyColumn,
        },
        {
          text: this.$t('app.contratacoes.list.headers.linhaDigitavelSgv'),
          value: 'linhaDigitavelSgv',
        },
        {
          text: this.$t('app.contratacoes.list.headers.vencimentoBoletoSgv'),
          value: 'vencimentoBoletoSgv',
          component: DataTableDateOnlyColumn,
          orderBy: 'dataVencimentoBoletoSgv',
        },
        {
          text: this.$t('app.contratacoes.list.headers.valorBoletoProrrogacao'),
          value: 'valorBoletoProrrogacao',
          component: DataTableCurrencyColumn,
          orderBy: 'valorProrrogacaoTecfin',
        },
        {
          text: this.$t('app.contratacoes.list.headers.nossoNumero'),
          value: 'nossoNumero',
        },
        {
          text: this.$t('app.contratacoes.list.headers.linhaDigitavelProrrogacao'),
          value: 'linhaDigitavelProrrogacao',
        },
        {
          text: this.$t('app.contratacoes.list.headers.vencimentoBoletoProrrogacao'),
          value: 'vencimentoBoletoProrrogacao',
          component: DataTableDateOnlyColumn,
          orderBy: 'dataVencimentoProrrogacaoTecfin',
        },
        {
          text: this.$t('app.contratacoes.list.headers.dataRepasseMoneyGc'),
          value: 'dataRepasseMoneyGc',
          component: DataTableDateOnlyColumn,
        },
        {
          text: this.$t('app.contratacoes.list.headers.prazo'),
          value: 'prazo',
        },
        {
          text: this.$t('app.contratacoes.list.headers.valorRepasseGrupoCard'),
          value: 'valorRepasseGrupoCard',
          component: DataTableCurrencyColumn,
        },
        {
          text: this.$t('app.contratacoes.list.headers.actions'),
          value: '',
          component: BotoesAcaoColumn,
        },
      ],
      requestClass: ContratacoesRequest,
      hideEdit: true,
      hideDelete: true,
    };
  },
  created() {
    this.$root.$on('refresh-crud', () => {
      this.getData();
    });
  },
  methods: {
    getFaultFilterList() {
      return {
        dataFinal: Moment().format('YYYY-MM-DD'),
        dataInicial: Moment().subtract(90, 'days').format('YYYY-MM-DD'),
      };
    },
  },
};
</script>
